import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {Cloneable} from "@/common/Cloneable";
import {ItemDeprecateMode} from "@/modules/redactor/models/item/deprecate/ItemDeprecateMode";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";
import {Range} from "@/modules/redactor/models/utils/Range";


export class ItemDeprecateConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                if (v && v.mode.equal(ItemDeprecateMode.DEFAULT)) {
                    v.guard = null;
                }

                return v && !v.empty() ? serialize(ItemDeprecateConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemDeprecateConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._mode = ItemDeprecateMode.DISABLED;
        this._silent = false;

        this._overflow = 0;
        this._lifetime = null;

        this._guard = null;
        this._reward = null;
    }

    get mode() {
        return this._mode;
    }

    set mode(value) {
        this._mode = value;
    }

    get silent() {
        return this._silent;
    }

    set silent(value) {
        this._silent = value;
    }

    get overflow() {
        return this._overflow;
    }

    set overflow(value) {
        this._overflow = value;
    }

    get lifetime() {
        return this._lifetime;
    }

    set lifetime(value) {
        this._lifetime = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (this.mode.equal(ItemDeprecateMode.DISABLED)) {
            return true;
        } else if (this.mode.equal(ItemDeprecateMode.GUARD)) {

            if (!Number.isInteger(this.overflow) || this.overflow < 0) {
                return false;
            }

            if (!this.guard || this.guard.empty() || !this.guard.valid()) {
                return false;
            }

        } else if (this.mode.equal(ItemDeprecateMode.LIFETIME)) {

            if (!this.lifetime || !this.lifetime.valid()) {
                return false;
            }
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return this.mode.equal(ItemDeprecateMode.DISABLED);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemDeprecateConfig());
        } else if (target instanceof ItemDeprecateConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemDeprecateConfig, {
    _mode: alias("mode", ItemDeprecateMode.schema()),
    _silent: alias("silent", Schema.primitive()),

    _overflow: alias("overflow", Schema.primitive()),
    _lifetime: alias("lifetime", Range.schema()),

    _guard: alias("guard", GuardConfig.schema()),
    _reward: alias("reward", RewardModel.schema())
});